export const ADMIN_SESSION_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const ADMIN_SESSION_IDLE_WARNING_LEAD_MS = 60 * 1000;
export const ADMIN_SESSION_IDLE_WARNING_MS =
  ADMIN_SESSION_IDLE_TIMEOUT_MS - ADMIN_SESSION_IDLE_WARNING_LEAD_MS;
export const ADMIN_SESSION_IDLE_TIMEOUT_SECONDS = ADMIN_SESSION_IDLE_TIMEOUT_MS / 1000;
